export default __webpack_public_path__ + "static/media/cresuFond.83be5d60.jpg";